import request from '@/utils/request'

// 获取图片验证码
export function showScreen () {
  return request.get('/business/show/show')
}